// Cột phải của modal vùng ký: mỗi bên ký một thẻ, thêm/xem/xóa được nhiều vùng.
// Panel không đụng tới PDF — nó chỉ phát lệnh qua setHandleActionDocument.
import "./AgreementSignZone.scss";

import MessageFormValidate from "components/shared-components/MessageFormValidate";
import {
  getSignZoneDefaultRect,
  SIGN_ZONE_ACTION,
  SIGN_ZONE_COLOR,
} from "constants/AgreementSignZoneConstant";
import { createZoneInfo } from "pages/IssueInvoice/helper/agreementSignZone";
import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import { useFieldArray } from "react-hook-form";
import { Button, Card, CardBody, Col, Row } from "reactstrap";

// Một thẻ = một bên ký
const SignZoneCard = props => {
  const {
    mainForm,
    nestIndex,
    setHandleActionDocument,
    isDisabled,
    isPdfReady,
    typeReport,
  } = props;

  const {
    control,
    getValues,
    watch,
    formState: { errors },
  } = mainForm;

  const prefixZoneInfos = `sign_zones.${nestIndex}.zone_infos`;

  const {
    fields: zoneInfos,
    append: appendZoneInfo,
    remove: removeZoneInfo,
  } = useFieldArray({
    control,
    name: prefixZoneInfos,
  });

  const signZone = watch(`sign_zones.${nestIndex}`);
  const stroke = SIGN_ZONE_COLOR[signZone?.node_code];
  const errorZoneInfos = errors?.sign_zones?.[nestIndex]?.zone_infos;

  /**
   * @param {object | null} defaultRect toạ độ đặt sẵn cho khung; bỏ trống thì
   *   khung rơi ở góc trên trang hiện tại để người dùng tự kéo
   */
  const handleAddZone = (defaultRect = null) => {
    const zoneInfo = {
      ...createZoneInfo(getValues(`sign_zones.${nestIndex}`)),
      ...(defaultRect || {}),
    };

    // Đánh dấu đã vẽ ngay lúc thêm: khung được tạo trên PDF cùng lúc
    appendZoneInfo(
      { ...zoneInfo, zone_is_created: true },
      { shouldFocus: false }
    );
    console.log("setHandleActionDocument", { signZone, zoneInfo });
    setHandleActionDocument({
      action: SIGN_ZONE_ACTION.CREATE,
      field: zoneInfo.zone_id,
      content: `Vùng ký của ${signZone?.node_name}`,
      format: {
        width: zoneInfo.zone_width || signZone?.data?.sign_digital_width,
        height: zoneInfo.zone_height || signZone?.data?.sign_digital_height,
        x: zoneInfo.zone_x,
        y: zoneInfo.zone_y,
        // Chỉ khung đặt sẵn mới có trang cố định (vd biên bản INFO ký ở trang 2).
        // Nút "Thêm vùng ký" không truyền: createZoneInfo luôn để zone_page 0,
        // gửi đi sẽ kéo khung về trang 1 thay vì trang người dùng đang xem.
        page: defaultRect ? zoneInfo.zone_page : undefined,
        stroke,
      },
    });
  };

  // Tự tạo vùng ký mặc định khi bên này chưa có vùng nào.
  // Phải đợi PDF nạp xong, nếu không lệnh CREATE gửi vào iframe sẽ rơi mất.
  // Chỉ thẻ đầu tiên còn thiếu mới được chạy: mỗi lần chỉ phát một lệnh CREATE,
  // thẻ sau tự tới lượt ở vòng render kế tiếp.
  const hasAutoAddedRef = useRef(false);
  const allSignZones = watch("sign_zones") || [];
  const firstEmptyIndex = allSignZones.findIndex(
    item => !(item?.zone_infos?.length > 0)
  );
  const shouldAutoAddZone = isPdfReady && firstEmptyIndex === nestIndex;

  useEffect(() => {
    if (!shouldAutoAddZone || hasAutoAddedRef.current) {
      return;
    }
    hasAutoAddedRef.current = true;
    // Mỗi loại biên bản có bố cục khác nhau nên chỗ ký mặc định cũng khác
    handleAddZone(getSignZoneDefaultRect(typeReport));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldAutoAddZone]);

  return (
    <Card style={{ border: `1px solid ` }}>
      <CardBody className="agreement-sign-zone-panel__card-body">
        <div className="d-flex align-items-center mb-3">
          <i
            className="bx bxs-user-circle font-size-20 me-2"
            style={{ color: stroke }}
          />
          <strong className="font-size-18">
            {signZone?.node_name}
            {/* {zoneInfos.length > 0 ? ` (${zoneInfos.length})` : ""} */}
          </strong>
        </div>

        {zoneInfos.map((fieldInfo, indexInfo) => {
          const zoneId = getValues(`${prefixZoneInfos}.${indexInfo}.zone_id`);
          const errorZone = errorZoneInfos?.[indexInfo];

          return (
            <div key={fieldInfo.id} className="mb-2">
              <div className="d-flex gap-2">
                <Button
                  type="button"
                  color="info"
                  className="btn-label"
                  outline
                  disabled={isDisabled}
                  onClick={() =>
                    setHandleActionDocument({
                      action: SIGN_ZONE_ACTION.VIEW,
                      field: zoneId,
                    })
                  }
                >
                  <i className="bx bx-show me-1 label-icon" />
                  Xem vùng ký
                </Button>
                {/* <Button
                  type="button"
                  color="danger"
                  size="sm"
                  outline
                  disabled={isDisabled}
                  onClick={() => {
                    setHandleActionDocument({
                      action: SIGN_ZONE_ACTION.DELETE,
                      field: zoneId,
                    });
                    removeZoneInfo(indexInfo);
                  }}
                >
                  <i className="bx bx-trash me-1" />
                  Xóa vùng
                </Button> */}
              </div>
              <MessageFormValidate
                error={
                  errorZone?.zone_width?.message ||
                  errorZone?.zone_height?.message ||
                  ""
                }
              />
            </div>
          );
        })}

        {/* <Button
          type="button"
          color="primary"
          className="btn-label"
          disabled={isDisabled}
          onClick={() => handleAddZone()}
        >
          <i className="bx bx-plus label-icon" />
          Thêm vùng ký
        </Button> */}
        <MessageFormValidate error={errorZoneInfos?.message || ""} />
      </CardBody>
    </Card>
  );
};

SignZoneCard.propTypes = {
  mainForm: PropTypes.object.isRequired,
  nestIndex: PropTypes.number.isRequired,
  setHandleActionDocument: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isPdfReady: PropTypes.bool,
  typeReport: PropTypes.string,
};

const AgreementSignZonePanel = props => {
  const {
    mainForm,
    setHandleActionDocument,
    isDisabled,
    isPdfReady,
    typeReport,
  } = props;

  const signZones = mainForm.watch("sign_zones") || [];

  return (
    <Row xs="1" className="gy-3 agreement-sign-zone-panel">
      {signZones.map((signZone, index) => (
        <Col key={signZone.node_code}>
          <SignZoneCard
            mainForm={mainForm}
            nestIndex={index}
            setHandleActionDocument={setHandleActionDocument}
            isDisabled={isDisabled}
            isPdfReady={isPdfReady}
            typeReport={typeReport}
          />
        </Col>
      ))}
    </Row>
  );
};

AgreementSignZonePanel.propTypes = {
  mainForm: PropTypes.object.isRequired,
  setHandleActionDocument: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isPdfReady: PropTypes.bool,
  // Loại biên bản (TYPE_REPORT_WORD) — quyết định vị trí vùng ký mặc định
  typeReport: PropTypes.string,
};

AgreementSignZonePanel.defaultProps = {
  isDisabled: false,
  isPdfReady: false,
};

export default AgreementSignZonePanel;
